import { Container, Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import profileImg from '../../../images/profileImg.png'

const AboutMe = () => {
    return (
        <Container sx={{mt: 10, }}>
            <Paper id="aboutMe" elevation={0} style={{ padding: "40px 30px", backgroundColor: '#f5f5f5' }}>
                <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item sm={7} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Typography sx={{fontWeight: 500}} variant="h4" gutterBottom component="div">
                        About Me
                    </Typography>
                    <Typography variant="body1" gutterBottom component="div">
                        I am Md. Mahadi Hassan Riyadh, a junior MERN stack web developer from Bangladesh. Currently I am styding at BRAC University in Computer Science and Engineering Department.
                        </Typography>
                        <br />
                    <Typography variant="body1" gutterBottom component="div">
                        I love playing with new technologies and learn about them. Spending my time in learning more about technologies everyday make me feel good. Currently I am looking for amazing projects to work on.
                    </Typography>
                        <br />
                    <Typography variant="body1" gutterBottom component="div">
                        I am an young Entrepreneur too. Currently I run two small facebook based businesses and working on an idea.
                    </Typography>
                    </Grid>
                    <Grid item sm={5} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <Box>
                            <img style={{width: "100%"}} src={profileImg} alt="" />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    );
};

export default AboutMe;